import { NgModule, isDevMode, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { PageRibbonComponent } from './page-ribbon/page-ribbon.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FloorPlanModule } from './floor-plan/floor-plan.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CurrencyCopPipe } from './shared/pipes/currency-cop.pipe';
import { ConfiguracionService } from './shared/services/configuracion.service';
import { environment } from '../environments/environment';

export function loadConfigFromIndexedDB(config: ConfiguracionService): () => Promise<void> {
  return () => (environment.demo ? config.loadFromIndexedDB() : Promise.resolve());
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AppRoutingModule,
    FloorPlanModule,
    CurrencyCopPipe,
    PageRibbonComponent,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: loadConfigFromIndexedDB,
      deps: [ConfiguracionService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
